import { Sparkles } from "lucide-react";

const PROFILES = [
  "Dyslexie — lecture",
  "TDAH — attention et organisation",
  "Autisme (TSA) — structure et communication",
  "Dyscalculie — mathématiques",
  "Dysgraphie — écriture",
  "Trouble développemental du langage (TDL)",
  "Anxiété liée aux études ou aux évaluations",
  "Difficultés de mémoire de travail",
  "Apprentissage avancé / haut potentiel",
  "Rythme de traitement plus lent",
];

/** Preview only: learning preferences are shown but not saved or used yet. */
export const LearningNeedsPreview = ({ studentId }) => (
  <div className="mt-4 rounded-2xl border border-dashed border-gray-200 bg-[#FBFCFC] p-4" data-testid={`learning-needs-${studentId}`}>
    <div className="flex items-center justify-between gap-2">
      <p className="text-sm font-semibold text-[#122118]">Besoins et préférences d’apprentissage</p>
      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-[#FFF4D6] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#9a6b00]" data-testid={`learning-needs-soon-${studentId}`}>
        <Sparkles className="h-3 w-3" /> Bientôt disponible
      </span>
    </div>
    <p className="mt-1 text-xs text-[#4a5f53]">
      Cochez les éléments qui peuvent aider votre enfant. Plan Étude adaptera ses explications, ses séances et ses rappels. Ces choix sont facultatifs et peuvent être modifiés à tout moment.
    </p>
    <fieldset disabled className="mt-3 grid gap-1.5 opacity-60 sm:grid-cols-2">
      {PROFILES.map((label) => (
        <label key={label} className="flex items-start gap-2 text-xs text-[#122118]">
          <input type="checkbox" className="mt-0.5" />
          {label}
        </label>
      ))}
    </fieldset>
    <p className="mt-2 text-[11px] text-[#829C8D]">Ce ne sont pas des diagnostics. Choisissez seulement les adaptations utiles pour votre enfant.</p>
    <input
      disabled
      placeholder="Autres préférences (ex. : préfère les exemples visuels)"
      className="mt-2 w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs opacity-60"
      aria-label="Autres préférences"
    />
    <p className="mt-2 text-[11px] font-semibold text-[#9a6b00]">Cette section arrive bientôt : vos choix ne sont pas encore enregistrés.</p>
  </div>
);
